import { isObject } from "lodash";

interface ApiErrorParams {
  body?: unknown;
  errorDetails?: string | Record<string, any>;
  message: string;
  response?: Response;
  status: number;
  statusText: string;
}

export class ApiError extends Error {
  status: number;
  statusText: string;
  errorDetails?: string | Record<string, any>;
  body?: any;
  firstErrorDetail?: any;
  response?: Response;

  constructor({
    status,
    statusText,
    message,
    errorDetails,
    body,
    response,
  }: ApiErrorParams) {
    super(message);
    this.status = status;
    this.statusText = statusText;
    this.errorDetails = errorDetails;
    this.body = body;
    this.response = response;

    if (isObject(errorDetails)) {
      this.firstErrorDetail = Object.values(errorDetails)?.[0];
    }
  }
}

interface NotFoundErrorParams {
  message: string;
}

export class NotFoundError extends Error {
  status: number;

  constructor({ message }: NotFoundErrorParams) {
    super(message);
    this.status = 404;
  }
}
